/**
 * Formats a string into a standard Canadian postal code format (A1A 1A1).
 *
 * @param {string} postalCode - The input postal code to format.
 * @returns {string} - The formatted postal code.
 */
export const formatCanadaPostalCode = (postalCode: string): string => {
  // Remove all non-alphanumeric characters
  let cleaned = postalCode.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  // Ensure the format is correct: A1A 1A1
  if (cleaned.length > 3) {
    cleaned = `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)}`;
  }

  return cleaned;
};
